import React, { useEffect, useState } from "react";//added approval button,modal and included its functions
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { getClosingManagerList} from '../../reduxStore/action/closingManagerAction'
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import moment from "moment";
import Select from "react-select";
import Button from "component/Button";



const ClosingManagerList = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [closingManagerList, setClosingManagerList] = useState([]);
 
  const closingManagerSelecter = useSelector(
    (state) => state?.cmData
  );


    const permissionSelector = useSelector((state) => state.permission);
 

    const {response:res} = useSelector((state) => state.login)

  
  const { view,edit } = usePermission({
    view: "closing_manager_detail",
    edit:"edit_closing_manager"
  });


 
  const navigatpage = async (navname) => {
    navigate(navname);
  };


  useEffect(() => {
    dispatch(getClosingManagerList({}));
  }, [dispatch]);

  

  useEffect(() => {
    const { response = null, create = false } = closingManagerSelecter;
    if (response && response?.status === 200) {

      if (!create && response.data?.length > 0) {
        setClosingManagerList(
          handleListResponse(response?.data) ? response?.data : []
        );
      }
    } else {
      setClosingManagerList([]);
    }
  }, [closingManagerSelecter]);

   

  

  
  return (
    <div className="page-body">
      {/* Model_start */}
    
      {/* Model_end */}
      <Breadcrumb
        title={strings.closingManager}
        titleactive={strings.closingManagerListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div  className="card-header">
                    <h5>{strings.closingManagerList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.name}</th>
                          <th scope="col">{strings.noBookings}</th>
                          <th scope="col">{strings.mobileNo}</th>
                          <th scope="col">{strings.email}</th>
                          <th scope="col">{strings.lastLogin}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {closingManagerList?.length > 0 ? (
                          closingManagerList.map((item, index) => {
                            return (
                              <tr key={item._id}>
                                <td style={{ inlineSize: "130px" }}>
                                  {item?.user_name}
                                </td>
                                <td>
                                  {item.total_booking}
                                </td>
                                <td>{item.mobile}</td>
                                <td>{item.email}</td>
                                <td>{new Date(item.last_login).toISOString().split('T')[0]}</td>
                               
                                <td className="p-2">
                                  {view && (
                                    <i
                                      className="fa fa-eye theme-fa-icon p-2"
                                      aria-hidden="true"
                                      title={strings.viewClosingManager}
                                      onClick={() => {
                                        navigatpage(
                                          `/viewClosingManager/${item._id}`
                                        );
                                      }}
                                    ></i>
                                  )}
                                  {/* {edit && (
                                    <i
                                      className="fa fa-edit theme-fa-icon "
                                      aria-hidden="true"
                                      title={strings.editClosingManager}
                                      onClick={() => {
                                        navigatpage(
                                          `/edit_closing_manager?cm_id=${item._id}`
                                        );
                                      }}
                                    ></i>
                                  )} */}
                                  
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                      {/* <i
                                    className="fa fa-edit theme-fa-icon"
                                    aria-hidden="true"
                                    data-toggle="modal"
                                    data-original-title="test"
                                    data-target="#exampleModal1"
                                    title="Allocation"
                                    onClick={() => {
                                      dispatch(
                                        cpCurrentMaping({
                                          agency_id: item?.login_id,
                                        })
                                      );
                                    }}
                                  ></i> */}
                    </table>
                    <TableDataNotFound data={closingManagerList} />
                  </div>
             
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        
    </div>
  );
};
export default ClosingManagerList;
